import { css, cssManager } from '@design.estate/dees-element';

export const tilePdfStyles = css`
  .preview-stack {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 8px 8px 28px 8px;
  }

  .preview-stack.non-a4 {
    padding: 12px 12px 28px 12px;
  }

  .preview-canvas {
    position: relative;
    background: white;
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    image-rendering: auto;
    -webkit-font-smoothing: antialiased;
    box-shadow: var(--dees-shadow-sm);
  }

  .non-a4 .preview-canvas {
    border: 1px solid var(--dees-color-border-default);
    border-radius: 4px;
  }

  /* Grid optimizations */
  :host([grid-mode]) .preview-canvas {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
`;
